<div class="auth-page-wrapper">
  <div class="auth-form-container auth-form-side">
    <div class="auth-card" style="max-width:500px;width:100%">
        <a routerLink="/login" class="auth-back-link">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <polyline points="15 18 9 12 15 6"/>
          </svg>
          Back to login
        </a>

        <div class="reset-header">
          <img src="assets/logo.png" alt="RAD" class="reset-logo"/>
          <div class="auth-icon-wrap auth-icon-wrap--orange" style="margin:0 auto 1rem">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
              <path d="M7 11V7a5 5 0 0110 0v4"/>
            </svg>
          </div>
          <h1 class="auth-heading" style="text-align:center">Reset Your Password</h1>
          <p class="auth-subheading" style="text-align:center">Enter your email address and we'll send you a verification code to reset your password.</p>
        </div>

        <form [formGroup]="resetForm" (ngSubmit)="onRequestReset()" class="reset-form">
          <div class="form-section">
            <div class="auth-field">
              <input
                class="auth-input"
                formControlName="email"
                type="email"
                placeholder=" "
                >
              <label>Email Address</label>
              @if (emailControl?.invalid && emailControl?.touched) {
                <mat-error class="auth-error">
                  @if (emailControl?.errors?.['required']) {
                    Email is required
                  } @else if (emailControl?.errors?.['email']) {
                    Please enter a valid email address
                  }
                </mat-error>
              }
            </div>
          </div>

          <!-- Error Message -->
          @if (error) {
            <div class="error-message">
              <mat-icon>error</mat-icon>
              <span>{{error}}</span>
            </div>
          }

          <!-- Success Message -->
          @if (success) {
            <div class="success-message">
              <mat-icon>check_circle</mat-icon>
              <span>{{success}}</span>
            </div>
          }

          <!-- Submit Button -->
          <div class="form-actions">
            @if (loading) {
              <button
                type="submit"
                mat-raised-button
                color="primary"
                class="reset-button btn-primary btn-full btn-lg"
                disabled>
                <span class="btn-spinner"></span>
                Sending...
              </button>
            } @else {
              <button
                type="submit"
                mat-raised-button
                color="primary"
                class="reset-button btn-primary btn-full btn-lg"
                [disabled]="resetForm.invalid">
                Send Reset Code
              </button>
            }
          </div>
        </form>

        <!-- Footer -->
        <div class="reset-footer">
          <p class="auth-footer">Remember your password? <a routerLink="/login" class="login-link">Log in here</a></p>
        </div>
    </div>
  </div>
  <div class="auth-image-container">
    <img src="assets/auth/passwordImage.webp" alt="Reset Password Image">
  </div>
</div>
